import App from "../main";
import Vue from 'vue';

export function appendModal(Modal, parent, propsData) {
  let modal = Vue.extend(Modal);

  return new modal({propsData: propsData, parent: parent})
  .$mount(createModalSlot());
}

export function destroyModal(vm) {
  // destroy the vue listeners, etc
  vm.$destroy();

  // remove the element from the DOM
  vm.$el.parentNode.removeChild(vm.$el);
}

function createModalSlot () {
  const container = document.getElementById('page-modals');

  // create an ephemeral div to mount the component into
  const modalSlot = document.createElement('div')
  // add it to `div#app`
  container.appendChild(modalSlot)
  return modalSlot;
}

export function prependModal(Modal, parent, propsData) {
  let modal = Vue.extend(Modal);

  return new modal({propsData: propsData, parent: parent})
    .$mount(createBeforeModalSlot());
}
function createBeforeModalSlot () {
  const container = document.getElementById('before-modal-container');

  // create an ephemeral div to mount the component into
  const modalSlot = document.createElement('div')
  // add it to `div#app`
  container.appendChild(modalSlot)
  return modalSlot;
}


